const e=async(e,t,n,r)=>{await e.delete(`/orgs/${n}/apps/${t}/users/${r}`)};export{e as unassignOrgAppUser};
//# sourceMappingURL=unassign-org-app-user.mjs.map